export default __webpack_public_path__ + "static/floripa-por-do-sol-eaf142daad4809db8bf2a388ec650d48.webp";